import { useState } from "react";
import AccessTokensCard, {
  CreatedTokenBanner,
} from "./components/access-tokens-card";
import McpSnippetsCard from "./components/mcp-snippets-card";

/**
 * Unlisted page (no sidebar entry): reachable at /shops/:shopId/mcp to create a
 * personal access token and try the MCP endpoint against it.
 */
export default function McpPage() {
  const [createdToken, setCreatedToken] = useState<string | null>(null);

  return (
    <div className="flex flex-col gap-6 p-6 max-w-3xl">
      <div className="flex flex-col gap-1">
        <h1 className="text-2xl font-semibold">MCP</h1>
        <p className="text-sm text-muted-foreground">
          Read-only tools over MCP: <code>list_my_shops</code> and{" "}
          <code>get_shop_portal_config</code>, which returns the configuration
          the customer return portal actually renders itself from.
        </p>
      </div>

      <AccessTokensCard onTokenCreated={setCreatedToken} />

      {createdToken ? <CreatedTokenBanner token={createdToken} /> : null}

      <McpSnippetsCard token={createdToken ?? undefined} />
    </div>
  );
}
